export default "__VITE_ASSET__8cbca422__"